import useAppModal from 'hooks/useAppModal';
import useFetchPricingPlan from '../../useFetchPricingPlan';
import UpgradePlanModal from './UpgradePlanModal';
import { upgradePlanModalId } from './UpgradePlanModal.constants';

const useUpgradePlanModal = () => {
  const { data: pricingPlan } = useFetchPricingPlan();
  const { openModal } = useAppModal();

  const openUpgradePlanModal = () => {
    openModal({
      customContent: <UpgradePlanModal />,
      id: upgradePlanModalId,
      size: 'medium',
    });
  };

  const canAddProperties = (amountToAdd: number) => {
    // @ts-expect-error TS2339 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    const { currentPlan } = pricingPlan;
    // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    const nextPlan = pricingPlan.tierUpgradeOffer;

    if (!nextPlan) {
      return true;
    }

    const difference = currentPlan.propertiesLeftBeforeUpgrade - amountToAdd;

    return difference >= 0;
  };

  return {
    canAddProperties,
    openUpgradePlanModal,
  };
};

export default useUpgradePlanModal;
